export default __webpack_public_path__ + "static/media/a-day-at-the-museum.62348eb4.png";